module.exports = __webpack_public_path__ + "static/media/boquilla.13781059.png";